import { render } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from './contexts/theme'
import App from './App'
import './index.css'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

render(
  <ThemeProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ThemeProvider>,
  document.getElementById('root')
)

// Hold the splash for a full 5s from page load, then fade out
const splash = document.getElementById('splash')
if (splash) {
  const SPLASH_DURATION = 5000
  const remaining = Math.max(SPLASH_DURATION - performance.now(), 0)
  setTimeout(() => {
    splash.classList.add('fade-out')
    setTimeout(() => splash.remove(), 500)
  }, remaining)
}

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
    // Ensure visitors get the new build instead of a stale white screen
    window.location.reload()
  },
});